
import { Component, Prop, Vue } from 'vue-property-decorator';
import GaSendSite from '@/directives/GaSendSite';
import { isOptimaHotelUrl } from '@/lib/functions';
import store from '@/store';

interface PlanData {
  name: string;
  htl_id: string;
  plan: any;
}

// @ is an alias to /src
@Component({
  directives: {
    gasendsite: GaSendSite,
  },
})
export default class NaviEntryPlans extends Vue {
  private name = 'NaviEntryPlans';
  @Prop({default: false})
  private vertical!: boolean;
  @Prop({ default: (): HotelDetail[] => [] })
  private data!: HotelDetail[];
  get planDatas(): PlanData[] {
    const plans: PlanData[] = [];
    for (const hotel of this.data) {
      for (const plan of hotel.stayingPlans) {
        plans.push({
          name: hotel.name,
          htl_id: hotel.htl_id,
          plan,
        });
      }
    }
    return plans;
  }
  private getPlanUrl(item: PlanData): string {
    return item.plan.buttonUrl;
  }
  private buttonUrlWithMghrwcLinks(url: string): string {
    if (isOptimaHotelUrl(url) && store.getters['auth/mghrwc']) {
      return `/to-mghrwc?redirect=${encodeURIComponent(url)}`;
    }
    return url;
  }
  private buttonLabel(hotelData: PlanData): string {
    if (hotelData.plan.buttonLabelLong.length > 0) {
      return hotelData.plan.buttonLabelLong;
    } else {
      return `「${hotelData.name}」を特別優待料金で予約する`;
    }
  }
}
